// Página de Producción por Rama
import React from 'react';

const ProduccionRama = () => {
  return (
    <div>
      <h2>Producción por Rama</h2>
      {/* Aquí irá la gráfica de producción por rama */}
    </div>
  );
};

export default ProduccionRama;
